import { Path } from 'react-hook-form';
import { GenerateContractFormValues } from './types';

export const MAX_CHARACTER_COUNT_SUBJECT = 100;
export const MAX_CHARACTER_COUNT_MESSAGE = 1000;

export const DEFAULT_VALUES = {
    templates: {
        selectedTemplates: {},
    },
};

export const FORM_FIELD_PATHS = {
    selectedTemplates: 'templates.selectedTemplates',
    selectedAttachments: 'templates.selectedAttachments',
    recipients: 'recipients.recipients',
    uploadedFiles: 'templates.uploadedFiles',
} as const satisfies Record<string, Path<GenerateContractFormValues>>;
